/**
 * ⚠️ WARNING ⚠️
 * This file is automatically generated do not edit it manually",
 */
import React from "react";

import { info } from "../assets/info";
import { Icon, type IconBaseProps } from "../icon";

export const IconInfo = (props: IconBaseProps) => <Icon {...props} svg={info} />;

IconInfo.displayName = "IconInfo";
